module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"review_policy":"리뷰 운영방식"}}')
  delete Component.options._Ctor
}
